






















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import HotkeyLegend from '@/layouts/gripper/hotkeys/HotkeyLegend.vue';
import OptionListItem from '@/layouts/gripper/components/QuickLabeling/OptionListItem.vue';
import {Option} from '@/types/gripper';
import HotkeyListener from '@/layouts/gripper/hotkeys/HotkeyListener.vue';
import OptionButtonItem from '@/layouts/gripper/components/QuickLabeling/OptionButtonItem.vue';

@Component({
  components: {OptionButtonItem, HotkeyListener, OptionListItem, HotkeyLegend},
})

export default class OptionButtonBar extends Vue {
  @Prop(Array) public allPossibleOptions!: Option[];
  @Prop(Object) public selectedParameterOption!: Option;

  private indexInArray: number = 0;
  private hideLabels: boolean = false;

  private created() {
    if (this.selectedParameterOption) {
      this.indexInArray = this.allPossibleOptions.findIndex(
        (i: Option) => i.value === this.selectedParameterOption.value);
    }
  }

  private get getViewPortWidth() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    return vw;
  }

  private get isIpadOrPhone() {
    if (this.getViewPortWidth <= 1368) {
      return true;
    }
    return false;
  }

  private changeOption(option: Option) {
    this.indexInArray = this.allPossibleOptions.findIndex((i: Option) => i.value === option.value);
    this.$emit('onClickChangeOption', option);
  }

  private keyDown(origin: KeyboardEvent) {
    // check if the content of the string is a number (number pressed)
    const isNumber = /^[0-9]$/i.test(origin.key);
    if (isNumber) {
      const numberPressed: number = +origin.key;
      const resource = this.allPossibleOptions[numberPressed - 1];
      this.$emit('numberKeyPressed', resource);
    } else {
      if (origin.key === 'Enter') {
        this.$emit('enterKeyPressed');
      }
      switch (origin.key) {
        case ']':
          // Check if we can traverse to a lower row
          if (this.indexInArray + 1 < this.allPossibleOptions.length) {
            this.changeOption(this.allPossibleOptions[this.indexInArray + 1]);
          }
          break;
        case '[':
          // Check if we can traverse to an upper row
          if (this.indexInArray > 0) {
            this.changeOption(this.allPossibleOptions[this.indexInArray - 1]);
          }
          break;
        case 'ArrowRight':
          // Tab through the possible options
          this.indexInArray = (this.indexInArray + 1) % this.allPossibleOptions.length;
          this.changeOption(this.allPossibleOptions[this.indexInArray]);
          break;
      }
    }
  }

}
